import { createSelector } from '@reduxjs/toolkit';
import { selectActivityLocationFromContentDetailState, selectExpandedAccordionFromDetailState } from 'component/page/detail/store/detail.selectors';
import { DetailContentOnToggleProps } from 'component/page/detail/DetailPageContent/DetailPageContent.selectors';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import { ExpandedAccordionDict } from 'core/type/Details.types';
import { LocationDetails } from 'component/page/detail/MoreInfoSections/Location/LocationCard';
import { ActivityLocation } from 'gql/autogen/ActivityLocation';

interface StateProps {
    cms: CmsValue;
    locationDetails: LocationDetails;
    expandedAccordion: ExpandedAccordionDict;
}

export type LocationProps = StateProps & DetailContentOnToggleProps;
export type LocationModularProps = StateProps;

export const mapLocationDetails = (detail: ActivityLocation | undefined): LocationDetails => {
    return {
        locationName: detail?.country?.name || '',
        locationAddress: detail?.city?.name || '',
        lat: detail?.geo?.lat || 0,
        long: detail?.geo?.long || 0,
    };
};

export const mapStateToProps = createSelector(
    selectCmsFromBootstrap,
    selectActivityLocationFromContentDetailState,
    selectExpandedAccordionFromDetailState,
    (cms, activityLocaiton, expandedAccordion) => {
        const locationDetails = mapLocationDetails(activityLocaiton);
        return { cms, locationDetails, expandedAccordion };
    },
);
